import { Injector, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'IdToNameConcatenator'
})
export class IdToNameConcatenatorPipe implements PipeTransform {
  RefValues: Array<any> = new Array<any>();
  constructor() {
  }

  transform(value: string, args: Array<any>): any {

    this.RefValues = args;
    let text = "";
    if (value != null && value != undefined) {
      let values = value.split(',')
      if (values.length > 0) {
        for (let index = 0; index < values.length; index++) {
          text += (this.RefValues.find((tuser) => {
            return tuser.id == values[index];
          })?.name + ',');
        }
      }
      if (text.endsWith(','))
        text = text.replace(',', '');
      //text = text.substring(text.length - 1, 1);
    }
    return text;
  }

}
